import { type VariantProps, cva } from 'class-variance-authority';

export const calendarPanelRootStyles = cva('sf-calendar flex w-full min-w-0 flex-col md:gap-4', {
  variants: {
    variant: {
      full: 'min-h-0 flex-1',
      widget: 'max-md:h-auto max-md:max-h-none h-[620px] max-h-[620px] min-h-0',
    },
  },
  defaultVariants: {
    variant: 'full',
  },
});

export const calendarPanelNavStyles = cva('md:flex hidden items-center gap-2 min-w-0 w-full justify-between', {
  variants: {
    variant: {
      full: 'max-w-[390px]',
      widget: 'max-w-[300px]',
    },
  },
  defaultVariants: {
    variant: 'full',
  },
});

export const calendarPanelLayoutStyles = cva('calendar-layout', {
  variants: {
    variant: {
      full: 'calendar-layout--full',
      widget: 'calendar-layout--widget',
    },
  },
  defaultVariants: {
    variant: 'full',
  },
});

export const calendarGridSkeletonStyles = cva(
  'flex h-full min-h-0 flex-col overflow-hidden rounded-[14px] border border-grey-300 bg-white',
  {
    variants: {
      variant: {
        full: '',
        widget: 'min-h-0',
      },
    },
    defaultVariants: {
      variant: 'full',
    },
  }
);

export type CalendarPanelVariantProps = VariantProps<typeof calendarPanelRootStyles>;
